import React from 'react';
import ScreenLayout from './ScreenLayout';
import ResponsiveCard from './ResponsiveCard';
import CardHeader from './CardHeader';
import ScrollableContent from './ScrollableContent';
import FixedActions from './FixedActions';

interface ResponsiveFormLayoutProps {
  // Screen Layout Props
  onBack?: () => void;
  showBackButton?: boolean;
  showLanguageToggle?: boolean;
  centerContent?: boolean;
  
  // Card Header Props
  icon?: string;
  title: string;
  subtitle?: React.ReactNode;
  iconSize?: string;
  progressValue?: number;
  
  /**
   * If true, the icon (logo) in the header will be displayed. Defaults to false
   * so that existing screens don't show the icon unless explicitly opted in.
   */
  showIcon?: boolean;
  
  // Content
  children: React.ReactNode;
  
  // Actions
  actions?: React.ReactNode;
  
  // Styling
  maxHeight?: string;
  className?: string;
}

const ResponsiveFormLayout: React.FC<ResponsiveFormLayoutProps> = ({
  onBack,
  showBackButton = false,
  showLanguageToggle = true,
  centerContent = false,
  icon,
  title,
  subtitle,
  iconSize,
  progressValue,
  showIcon = false,
  children,
  actions,
  maxHeight = '85vh',
  className = ''
}) => {
  return (
    <ScreenLayout 
      onBack={onBack}
      showBackButton={showBackButton}
      showLanguageToggle={showLanguageToggle}
      className={className}
      centerContent={centerContent}
    >
      <ResponsiveCard maxHeight={maxHeight}>
        <CardHeader 
          icon={icon}
          title={title}
          subtitle={subtitle}
          iconSize={iconSize}
          progressValue={progressValue}
          showIcon={showIcon}
        />
        
        <ScrollableContent>
          {children}
        </ScrollableContent>
        
        {actions && (
          <FixedActions>
            {actions}
          </FixedActions>
        )}
      </ResponsiveCard>
    </ScreenLayout>
  );
};

export default ResponsiveFormLayout; 